    
<template>
    <div style="display:inline-flex">
        <a-range-picker ref="cTimeRange" :disabled-date="disabledDate"
            :show-time="{
                        hideDisabledOptions: true,
                        format:'HH:mm'
                    }" :format="dateFormat"
            v-model="timeRange"
            @change="onChange" />

            <a-select v-model="timeCurrent" style="width: 80px;margin-left:20px;" @change="handleTypeChange">
                <a-select-option v-for="(value,name) in timeValue" :key="name" :value="name">
                    {{name}}
                </a-select-option>
            </a-select>
    </div>

</template>

<script>
import moment from 'moment';
const timeValue = {
    '1分钟':7,
    '5分钟':8,
    '15分钟':10,
    '1小时':9,
    '1天':11,
}
export default {
    data() {
        return {
            dateFormat:"YYYY-MM-DD HH:mm",
            timeRange:undefined,
            timeValue,
            timeType:9,
            timeCurrent:'1小时'
        }
    },
    props:{
        dataflag:Boolean
    },
    methods: {
        onChange(v,t){
            if(t[0] == t[1]){
                this.message.error("不能选择相同时间")
                return;
            }
            this.$emit("timeChanged",t[0] + "~" + t[1],this.timeType)
        },
        handleTypeChange(v){
            this.timeType = this.timeValue[v];
            this.timeRange  =this.getDefaultRange();
        },

        disabledDate(current) {
            // 日志库保存日期默认14天，可选择19天以内时间
            return current && current < moment().subtract(14, 'days');
        },

        getDefaultRange(){
            //默认一小时内
            let result = this.G.getRecentDate(this.timeType)
            let sTime = (new Date(result.start_time)).Format("yyyy-MM-dd hh:mm");
            let eTime = (new Date(result.end_time)).Format("yyyy-MM-dd hh:mm");
            this.$emit("timeChanged",sTime + "~" + eTime,this.timeType)
            return [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]

        },
        setTimeRange(start_time,end_time){
            let sTime = (new Date(start_time)).Format("yyyy-MM-dd hh:mm");
            let eTime = (new Date(end_time)).Format("yyyy-MM-dd hh:mm");
            this.$emit("timeChanged",sTime + "~" + eTime,this.timeType)
            this.timeType = 9;
            this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]
        },
        getCachedData(){
            let targetRange = '';
            let targetType = '';
            if(this.dataflag){
            //异常统计
                let query = this.$route.query;
                targetRange = query.searchTimeRange;
                targetType = query.dateTypeTitle;
            }
            else{
            //服务统计
                let monitorDetail = localStorage.getItem("monitorserviceDetailSearch");
                if(monitorDetail){
                    monitorDetail = JSON.parse(monitorDetail);
                    targetRange =  monitorDetail.searchTimeRange
                    targetType =  monitorDetail.timeType
                }
            }
            if(targetType){
                this.timeType = parseInt(targetType);
                for (const key in this.timeValue) {
                    if (this.timeValue.hasOwnProperty(key)) {
                        const element = this.timeValue[key];
                        if(element == this.timeType){
                            this.timeCurrent = key;
                            break;
                        }
                    }
                }
            }
            if(targetRange){
                let result = targetRange.split('~');
                let sTime = (new Date(result[0])).Format("yyyy-MM-dd hh:mm");
                let eTime = (new Date(result[1])).Format("yyyy-MM-dd hh:mm");
                this.$emit("timeChanged",sTime + "~" + eTime,this.timeType)
                this.timeRange = [moment(sTime, this.dateFormat), moment(eTime, this.dateFormat)]
            }
            else{
                this.timeRange = this.getDefaultRange();
            }
        }
    },
    mounted() {
        this.getCachedData();
        
    },

}
</script>

<style scoped>
    .active{
        color: #fff;
        background-color: #1890ff;
        border-color: #1890ff;
        text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
        -webkit-box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
        box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
    }
</style>
